import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EditModeService {
  inEditMode = false;
  editModeChanged$ = new EventEmitter();

  setEditMode(value: boolean) {
    this.inEditMode = value;
    this.editModeChanged$.emit();
  }
}
